import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Company } from '@farmfree/common/types/company/company'
import { createCompanyService } from '@/services/company/companyService'
import type { ApiResponse } from '@farmfree/common/types/apiResponse'

export const useCompanyStore = defineStore('company', () => {
  const items = ref<Company[]>([])
  const loading = ref(false)
  const error = ref<string>('')

  async function fetchAll(): Promise<ApiResponse<Company[]>> {
    loading.value = true
    try {
      const res = await createCompanyService('admin').getAll()
      if (res.isSuccess && res.data) {
        items.value = [...res.data]
        error.value = ''
      } else {
        error.value = res.message || '회사 목록 불러오기 실패'
      }
      return res
    } catch (err: any) {
      console.error('fetchAll 실패:', err)
      error.value = err.message || '예상치 못한 오류'
      return { isSuccess: false, message: error.value }
    } finally {
      loading.value = false
    }
  }

  return {
    items,
    loading,
    error,
    fetchAll,
  }
})
